import { Helmet } from 'react-helmet-async';
import { withRouter, useParams } from 'react-router-dom';
import qs from 'qs';

function ChangePassword(props) {
    const queryString = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    const { personnelId } = useParams();
    
    console.log(queryString.ReturnUrl);
    console.log(personnelId);

    return (
        <>
            <Helmet>
                <title>Change Password | CBRN Network</title>
            </Helmet>
            <div>
                
            </div>
        </>
    );
}

export default withRouter(ChangePassword);
